import React from 'react';
import { string, number, func } from 'prop-types';
import Datepicker from './Datepicker';

export default class DateRangeFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: '',
            endDate: ''
        };
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleApplyButtonClick = this.handleApplyButtonClick.bind(this);
    }

    handleDateChange(valueIndex, dateObject) {
        const { dateUpdate } = this.props;
        if (valueIndex === 0) {
            this.setState({ startDate: dateObject });
            if (dateUpdate) {
                dateUpdate('start', dateObject);
            }
        } else {
            this.setState({ endDate: dateObject });
            if (dateUpdate) {
                dateUpdate('end', dateObject);
            }
        }
    }

    handleApplyButtonClick() {
        if (this.state.startDate && this.state.endDate) {
            this.props.fetchData(this.state.startDate, this.state.endDate);
        }
    }

    render() {
        return (
            <div className={`date-range-wrapper date-range-filter ${this.props.classModifier}`}>
                <span className="filter-title">{this.props.label}</span>
                <div className="fl-filter-date-range-wrapper">
                    <Datepicker
                        datepickerID="filter-date-range-from"
                        placeholderText="From"
                        minDate={this.props.minDate}
                        maxDate={this.props.maxDate}
                        defaultDate={this.props.startDate}
                        handleDate={date => { this.handleDateChange(0, date); }}
                    />
                    <Datepicker
                        datepickerID="filter-date-range-to"
                        placeholderText="To"
                        minDate={this.props.minDate}
                        maxDate={this.props.maxDate}
                        defaultDate={this.props.endDate}
                        handleDate={date => { this.handleDateChange(1, date); }}
                    />
                </div>
            </div>
        );
    }
}


DateRangeFilter.propTypes = {
    label: string.isRequired,
    classModifier: string,
    minDate: number.isRequired,
    maxDate: number.isRequired,
    fetchData: func.isRequired,
    startDate: number.isRequired,
    endDate: number.isRequired,
    dateUpdate: func
};

DateRangeFilter.defaultProps = {
    classModifier: '',
    dateUpdate: null
};
